import React from "react"

const PaperFoldTextIcon: React.FC = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33325 13V5C5.33325 4.46957 5.54397 3.96086 5.91904 3.58579C6.29411 3.21071 6.80282 3 7.33325 3H19.3333C19.8637 3 20.3724 3.21071 20.7475 3.58579C21.1225 3.96086 21.3333 4.46957 21.3333 5V18C21.3333 19 20.7333 21 18.3333 21M18.3333 21H6.33325C5.33325 21 3.33325 20.4 3.33325 18V16H15.3333V18C15.3333 20.4 17.3333 21 18.3333 21ZM9.33325 7H17.3333M9.33325 11H13.3333"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PaperFoldTextIcon
